export const CONTROL_CENTER_PERMISSIONS = {
  read: 'platform.read',
  manage: 'platform.manage'
} as const;
